import React from 'react';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Tag from '../../../../../../muiComponents/Tag';
import Tooltip from '../../../../../../muiComponents/Tooltip';
import { useZitoneoUI } from '../../../../contexts/ZitoneoUIContext';
import { useZitoneoHotelRooms } from '../../../../contexts/ZitoneoContentContext';

const ZitoneoRoomTitle = () => {
    const translate = useTranslate();
    const { selectedRoomId } = useZitoneoUI();
    const { rooms } = useZitoneoHotelRooms();
    const selectedRoom = rooms.find(room => room.Id === selectedRoomId);
    return (
        <div className='services-page__room-title-container'>
            <div className='services-page__room-title-content'>
                <div className='flex gap-10 flex-align-center'>
                    <h3 className='services-page__room-title '>
                        {selectedRoom?.MainSupplierHotelRoomName}
                    </h3>
                    {selectedRoom?.MainSupplierHotelMappingCode ? (
                        <>
                            {'·'}
                            <Tooltip titleText='mapping_code'>
                                <span>
                                    <Tag
                                        text={
                                            selectedRoom?.MainSupplierHotelMappingCode ||
                                            '---'
                                        }
                                        variant='surface'
                                        color='grey'
                                    />
                                </span>
                            </Tooltip>
                        </>
                    ) : null}
                </div>
                <Tooltip placement='top-start' titleText='visible_name'>
                    <h4 className='services-page__room-master'>
                        {translate(selectedRoom?.MasterRoomName || '')}
                    </h4>
                </Tooltip>
            </div>
        </div>
    );
};

export default ZitoneoRoomTitle;
